/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon32Regular = forwardRef('MathDeltaIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m19.284 4.951 9.648 17.488C30.31 24.938 28.502 28 25.648 28H6.352c-2.854 0-4.662-3.062-3.283-5.561L12.717 4.95c1.426-2.584 5.14-2.584 6.567 0ZM17.08 7.7l8.618 15.32c.75 1.334-.214 2.981-1.743 2.981H6.72c-1.53 0-2.494-1.647-1.744-2.98L13.594 7.7c.764-1.36 2.722-1.36 3.486 0Z" })));
});
